module.exports = __webpack_public_path__ + "img/icon-nav-to-light-mode.7e259844.svg";